// –––––––––––––––––––––––––––– [ INTERPOLATION ]

const lerp = (x, y, a) => x * (1 - a) + y * a

// –––––––––––––––––––––––––––– [ PERFORMANCE ]

const throttle = (fn, delay) => {
    let time = Date.now()

    return () => {
        if (time + delay - Date.now() <= 0) {
            fn()
            time = Date.now()
        }
    }
}

// –––––––––––––––––––––––––––– [ GSAP ]

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)

// –––––––––––––––––––––––––––– [ LENIS ]

const lenis = new Lenis()

lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)

// –––––––––––––––––––––––––––– [ LAZYLOAD VIDEO ]

document.addEventListener('lazybeforeunveil', function (e) {
    const video = e.target
    if (video.tagName === 'VIDEO') {
        const sources = video.querySelectorAll('source')
        sources.forEach((source) => {
            if (source.dataset.src) {
                source.src = source.dataset.src
            }
        })

        if (video.dataset.autoplay !== undefined) {
            video.setAttribute('autoplay', '')
        }

        video.load()

        if (video.dataset.autoplay !== undefined) {
            video.play().catch((err) => {
                console.warn('Autoplay blocked:', err)
            })
        }
    }
})

// –––––––––––––––––––––––––––– [ CREDITS ]

console.log('%cSTRATA BLACK LABEL®', 'color: #b4b4b4; font-weight: bold;')
console.log(
    '%cDesign & Development by geminiservic.es → https://geminiservic.es',
    'color: #b4b4b4;',
)

// –––––––––––––––––––––––––––– [ LOOKBOOK ]

const setupLookbook = (lookbookNode) => {
    const lookbookSliderNode = lookbookNode.querySelector('.lookbook__slider')
    const lookbookContainerNode = lookbookNode.querySelector(
        '.lookbook__container',
    )

    // gsap.to(lookbookContainerNode, {
    //     x: () =>
    //         -(
    //             lookbookContainerNode.scrollWidth -
    //             lookbookSliderNode.offsetWidth
    //         ),
    //     ease: 'none',
    //     scrollTrigger: {
    //         trigger: lookbookSliderNode,
    //         start: 'top 100px',
    //         end: () =>
    //             '+=' +
    //             (lookbookContainerNode.scrollWidth -
    //                 lookbookSliderNode.offsetWidth),
    //         pin: document.querySelector('#index'),
    //         scrub: true,
    //         invalidateOnRefresh: true,
    //         // refreshPriority: 1,
    //     },
    // })

    const lookbookSlidesNodes =
        lookbookSliderNode.querySelectorAll('.lookbook__slide')

    for (const lookbookSlideNode of lookbookSlidesNodes) {
        lookbookSlideNode.addEventListener('click', () => {
            lookbookSlideNode.classList.toggle('is-enlarged')

            const handleTransitionEnd = () => {
                const scrollLeft = lookbookSliderNode.scrollLeft

                ScrollTrigger.refresh()
                lookbookSlideNode.removeEventListener(
                    'transitionend',
                    handleTransitionEnd,
                )

                lookbookSliderNode.scrollLeft = scrollLeft
            }

            lookbookSlideNode.addEventListener(
                'transitionend',
                handleTransitionEnd,
            )
        })
    }
}

const lookbooksNodes = document.querySelectorAll('.lookbook')

for (const lookbookNode of lookbooksNodes) {
    setupLookbook(lookbookNode)
}

// –––––––––––––––––––––––––––– [ PRODUCT GRID ]

const setupProductGridThumb = (thumbNode) => {
    thumbNode.addEventListener('click', () => {
        openProductModal(thumbNode)
    })
}

const changeProductGridLine = (productGridNode, lineId) => {
    const thumbsNodesSelectedOld = productGridNode.querySelectorAll(
        '.product-grid__thumbs.is-selected',
    )
    for (const thumbsNodeSelectedOld of thumbsNodesSelectedOld) {
        thumbsNodeSelectedOld.classList.remove('is-selected')
    }
    const lineIdOld = thumbsNodesSelectedOld[0]?.getAttribute('data-line-id')

    if (lineIdOld !== lineId) {
        const thumbsNodesSelected = productGridNode.querySelectorAll(
            `.product-grid__thumbs[data-line-id="${lineId}"]`,
        )
        for (const thumbsNodeSelected of thumbsNodesSelected) {
            thumbsNodeSelected.classList.add('is-selected')
        }
    }
}

const animateProductGridProducts = (
    productGridNode,
    view,
    thumbsNodes,
    thumbsNodesSelected,
) => {
    const productGridProductsNode = productGridNode.querySelector(
        '.product-grid__products',
    )

    const productGridCutandsewNode = productGridNode.querySelector(
        '.product-grid__cutandsew',
    )

    const tl = gsap.timeline({
        paused: true,
    })

    tl.to(thumbsNodes, {
        autoAlpha: 0,
        duration: 0.4,
    })
        .to(thumbsNodes, {
            duration: 0,
            display: 'none',
        })
        .to(productGridProductsNode, {
            duration: 0,
            display: () => {
                if (view === 'is-view-products' || view === 'is-view-line') {
                    return 'grid'
                } else {
                    return 'none'
                }
            },
            gridTemplateColumns: () => {
                if (view === 'is-view-line') {
                    return 'repeat(auto-fill, minmax(280px, 1fr))'
                } else {
                    return 'repeat(auto-fill, minmax(160px, 1fr))'
                }
            },
        })
        .to(productGridCutandsewNode, {
            duration: 0,
            display: () => {
                if (view === 'is-view-cutandsew') {
                    return 'block'
                } else {
                    return 'none'
                }
            },
        })
        .to(thumbsNodesSelected, {
            duration: 0,
            display: 'block',
        })
        .to(thumbsNodesSelected, {
            autoAlpha: 1,
            duration: 0.25,
            keyframes: [
                { opacity: 0, at: 0 },
                { opacity: 0.5, at: 0.14 },
                { opacity: 0.25, at: 0.28 },
                { opacity: 0.5, at: 0.42 },
                { opacity: 0.25, at: 0.56 },
                { opacity: 0.5, at: 0.7 },
                { opacity: 0.25, at: 0.84 },
                { opacity: 1, at: 1 },
            ],
            ease: 'none',
            stagger: {
                amount: 0.4,
                from: 'random',
            },
        })

    tl.seek(0).pause(0)
    tl.play()
}

const handleProductGridAnimations = (productGridNode, lineId) => {
    const productGridContainerNode = productGridNode.querySelector(
        '.product-grid__container',
    )

    const thumbsNodes = productGridNode.querySelectorAll(
        '.product-grid__thumbs',
    )

    const thumbsNodesSelectedOld = productGridNode.querySelectorAll(
        '.product-grid__thumbs.is-selected',
    )
    for (const thumbsNodeSelectedOld of thumbsNodesSelectedOld) {
        thumbsNodeSelectedOld.classList.remove('is-selected')
    }
    const lineIdOld = thumbsNodesSelectedOld[0]?.getAttribute('data-line-id')

    let thumbsNodesSelected = null

    if (lineIdOld === lineId || (!lineIdOld && lineId === 'Cut + Sew')) {
        thumbsNodesSelected = thumbsNodes
    } else if (lineId !== 'Cut + Sew') {
        thumbsNodesSelected = productGridNode.querySelectorAll(
            `.product-grid__thumbs[data-line-id="${lineId}"]`,
        )
        for (const thumbsNodeSelected of thumbsNodesSelected) {
            thumbsNodeSelected.classList.add('is-selected')
        }
    }

    if (productGridContainerNode.classList.contains('is-view-products')) {
        animateProductGridProducts(
            productGridNode,
            'is-view-products',
            thumbsNodes,
            thumbsNodesSelected,
        )
    } else if (productGridContainerNode.classList.contains('is-view-line')) {
        animateProductGridProducts(
            productGridNode,
            'is-view-line',
            thumbsNodes,
            thumbsNodesSelected,
        )
    } else if (
        productGridContainerNode.classList.contains('is-view-cutandsew')
    ) {
        animateProductGridProducts(
            productGridNode,
            'is-view-cutandsew',
            thumbsNodes,
            thumbsNodesSelected,
        )
    } else {
        animateProductGridProducts(
            productGridNode,
            'is-view-products',
            thumbsNodes,
            thumbsNodesSelected,
        )
    }
}

const setupProductGrid = (productGridNode) => {
    const thumbsNodes = productGridNode.querySelectorAll(
        '.product-grid__thumbs',
    )
    for (const thumbNode of thumbsNodes) {
        setupProductGridThumb(thumbNode)
    }

    const productGridContainerNode = productGridNode.querySelector(
        '.product-grid__container',
    )

    const filtersNodes = productGridNode.querySelectorAll(
        '.product-grid__filter',
    )
    for (const filterNode of filtersNodes) {
        filterNode.addEventListener('click', () => {
            const lineId = filterNode.getAttribute('data-line-id')

            const filterNodeSelectedOld = productGridNode.querySelector(
                '.product-grid__filter.is-selected',
            )
            if (filterNodeSelectedOld) {
                filterNodeSelectedOld.classList.remove('is-selected')
            }
            if (filterNodeSelectedOld !== filterNode) {
                filterNode.classList.add('is-selected')

                productGridContainerNode.classList.remove('is-view-products')
                if (lineId === 'Cut + Sew') {
                    productGridContainerNode.classList.remove('is-view-line')
                    productGridContainerNode.classList.add('is-view-cutandsew')
                } else {
                    productGridContainerNode.classList.remove(
                        'is-view-cutandsew',
                    )
                    productGridContainerNode.classList.add('is-view-line')
                }
            } else {
                productGridContainerNode.classList.remove('is-view-line')
                productGridContainerNode.classList.remove('is-view-cutandsew')
                productGridContainerNode.classList.add('is-view-products')
            }

            // changeProductGridLine(productGridNode, lineId)
            handleProductGridAnimations(productGridNode, lineId)
        })
    }

    gsap.to(thumbsNodes, {
        scrollTrigger: {
            trigger: productGridNode,
            start: 'top 60%',
            toggleActions: 'play none none none',
            once: true,
        },
        autoAlpha: 1,
        duration: 0.25,
        keyframes: [
            { opacity: 0, at: 0 },
            { opacity: 0.5, at: 0.14 },
            { opacity: 0.25, at: 0.28 },
            { opacity: 0.5, at: 0.42 },
            { opacity: 0.25, at: 0.56 },
            { opacity: 0.5, at: 0.7 },
            { opacity: 0.25, at: 0.84 },
            { opacity: 1, at: 1 },
        ],
        ease: 'none',
        stagger: {
            amount: 0.4,
            from: 'random',
        },
    })
}

const productGridsNodes = document.querySelectorAll('.product-grid')

for (const productGridNode of productGridsNodes) {
    setupProductGrid(productGridNode)
}

// JOSE VERSION

// const productGridsThumbs = document.querySelectorAll('.product-grid__thumb')
// for (const productGridThumb of productGridsThumbs) {
//     productGridThumb.addEventListener('click', () => {
//         openProductModal(productGridThumb.getAttribute('data-product-id'))
//     })
// }

// –––––––––––––––––––––––––––– [ PRODUCT MODAL ]

const productModalNode = document.querySelector('.product-modal')
const productModalBodyNode = document.querySelector('.product-modal__body')
const productModalBackdropNode = document.querySelector(
    '.product-modal__backdrop',
)
const closeNode = productModalNode.querySelector('.product-modal__close')

const setupProductModalSlider = () => {
    const sliderNode = productModalNode.querySelector('.product-modal__slider')
    const slidesNodes = sliderNode.querySelectorAll(
        '.product-modal__slider img',
    )
    const slidesNodesArray = [...slidesNodes]
    const thumbsNodes = productModalNode.querySelectorAll(
        '.product-modal__thumbs img',
    )

    let slideDistClosest = Infinity
    let slideNodeClosest = null
    let thumbNodeClosest = null

    const handleScroll = () => {
        if (slideNodeClosest && thumbNodeClosest) {
            slideNodeClosest.classList.remove('is-center')
            thumbNodeClosest.classList.remove('is-center')
            slideNodeClosest = null
            thumbNodeClosest = null
        }
        slideDistClosest = Infinity

        const sliderRect = sliderNode.getBoundingClientRect()
        const sliderCenterX = sliderRect.left + sliderRect.width / 2
        const sliderCenterY = sliderRect.top + sliderRect.height / 2

        slidesNodes.forEach((slideNode) => {
            const slideRect = slideNode.getBoundingClientRect()
            const slideCenterX = slideRect.left + slideRect.width / 2
            const slideCenterY = slideRect.top + slideRect.height / 2

            const slideDist = Math.hypot(
                slideCenterX - sliderCenterX,
                slideCenterY - sliderCenterY,
            )

            if (slideDist < slideDistClosest) {
                slideDistClosest = slideDist
                slideNodeClosest = slideNode
            }
        })

        if (slideNodeClosest) {
            const slideClosestIndex = slidesNodesArray.indexOf(slideNodeClosest)
            thumbNodeClosest = thumbsNodes[slideClosestIndex]

            thumbNodeClosest.classList.add('is-center')
            slideNodeClosest.classList.add('is-center')
        }
    }

    handleScroll()
    sliderNode.addEventListener('scroll', throttle(handleScroll, 50))

    const handleClick = (index) => {
        const slideNodeClicked = slidesNodes[index]

        const mq = window.matchMedia('(min-width: 768px)')

        if (mq.matches) {
            slideNodeClicked.scrollIntoView({
                behavior: 'smooth',
                container: 'nearest',
                block: index === 0 ? 'end' : 'center',
            })
        } else {
            sliderNode.scrollTo({
                left: index === 0 ? 0 : slideNodeClicked.offsetLeft,
                behavior: 'smooth',
            })
        }
    }

    for (let i = 0; i < thumbsNodes.length; i++) {
        const thumbNode = thumbsNodes[i]

        thumbNode.addEventListener('click', () => {
            handleClick(i)
        })
    }
}

gsap.registerPlugin(SplitText)

const animateProductModalText = (textNode, type) => {
    SplitText.create(textNode, {
        type: type,
        autoSplit: true,
        tag: 'div',
        smartWrap: true,
        linesClass: `split-text__${type}`,
        onSplit(self) {
            return gsap.from(self[type], {
                delay: 0.8,
                duration: 0.08,
                autoAlpha: 0,
                stagger: 0.1,
            })
        },
    })
}

const animateProductModalRichText = (textsNodes) => {
    const lines = []

    for (let i = 0; i < textsNodes.length; i++) {
        const textNode = textsNodes[i]

        if (i < textsNodes.length - 1) {
            const split = new SplitText(textNode, {
                type: 'lines',
                linesClass: 'split-text__lines',
            })
            lines.push(...split.lines)
        } else {
            const split = new SplitText(textNode, {
                type: 'lines',
                linesClass: 'split-text__lines',
                onSplit(self) {
                    return gsap.from([...lines, ...self.lines], {
                        delay: 0.8,
                        duration: 0.08,
                        autoAlpha: 0,
                        stagger: 0.1,
                    })
                },
            })
        }
    }
}

const animateProductModalOpen = gsap.timeline({
    paused: true,
    defaults: {
        ease: CustomEase.create('custom', 'M0,0 C0.4,0 0.2,1 1,1 '),
    },
})

animateProductModalOpen
    .to(productModalNode, {
        opacity: 1,
        duration: 0.4,
    })
    .addPause(0.6)
    .addLabel('reveal')
    .to(productModalNode, {
        height: 'calc(100svh - 80px)',
        duration: 0.6,
    })
    .addLabel('expand')

const animateProductModalClose = gsap.timeline({
    paused: true,
    defaults: {
        ease: CustomEase.create('custom', 'M0,0 C0.4,0 0.2,1 1,1 '),
    },
    onComplete: () => {
        productModalNode.classList.remove('is-open')
        productModalNode.classList.remove('is-swapped')
        document.body.classList.remove('is-lockscroll')

        productModalBodyNode.innerHTML = ''
    },
})

animateProductModalClose
    .to(productModalNode, {
        height: 56,
        duration: 0.6,
    })
    .to(productModalNode, {
        delay: 0.2,
        opacity: 0,
        duration: 0.4,
    })

const controlProductModalAnimations = () => {
    const chartColumnsNodes = productModalNode.querySelectorAll(
        '.product-modal__sizes__chart__column',
    )
    for (const chartColumnNode of chartColumnsNodes) {
        animateProductModalText(chartColumnNode, 'lines')
    }

    const descriptionSpansNodes = productModalNode.querySelectorAll(
        '.product-modal__description p span',
    )

    animateProductModalRichText(descriptionSpansNodes)

    const informationSpansNodes = productModalNode.querySelectorAll(
        '.product-modal__information span',
    )
    for (const informationSpanNode of informationSpansNodes) {
        animateProductModalText(informationSpanNode, 'words')
    }
}

const populateProductModalHeader = (thumbNode) => {
    const skuNode = productModalNode.querySelector('.product-modal__sku')
    const titleNode = productModalNode.querySelector('.product-modal__title')

    skuNode.textContent = thumbNode.getAttribute('data-product-sku')
    titleNode.textContent = thumbNode.getAttribute('data-product-title')
    titleNode.setAttribute('href', thumbNode.getAttribute('data-product-url'))
}

const setupProductModalATC = () => {
    const atcBtn = productModalNode.querySelector('.product-modal__atc__btn')
    if (!atcBtn) return

    const sizeButtons = productModalNode.querySelectorAll('.product-modal__atc__size')
    const variantsRaw = atcBtn.getAttribute('data-variants')
    let variants = []

    try {
        variants = JSON.parse(variantsRaw)
    } catch (e) {
        return
    }

    const hasSizes = sizeButtons.length > 0
    let selectedSize = null

    // If no sizes (single variant), enable immediately
    if (!hasSizes && variants.length > 0) {
        atcBtn.disabled = false
        atcBtn.dataset.variantId = variants[0].id
    }

    sizeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            if (btn.classList.contains('is-soldout')) return

            sizeButtons.forEach((b) => b.classList.remove('is-selected'))
            btn.classList.add('is-selected')
            selectedSize = btn.getAttribute('data-size')

            // Find matching available variant
            const variant = variants.find(
                (v) => v.available && v.options.includes(selectedSize),
            )

            if (variant) {
                atcBtn.disabled = false
                atcBtn.dataset.variantId = variant.id
                atcBtn.textContent = 'Add to Cart'
            } else {
                atcBtn.disabled = true
                delete atcBtn.dataset.variantId
                atcBtn.textContent = 'Unavailable'
            }
        })
    })

    atcBtn.addEventListener('click', async () => {
        const variantId = atcBtn.dataset.variantId
        if (!variantId || atcBtn.disabled) return

        atcBtn.classList.add('is-adding')
        atcBtn.textContent = 'Adding...'

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{ id: parseInt(variantId, 10), quantity: 1 }],
                }),
            })

            if (!response.ok) {
                const err = await response.json()
                throw new Error(err.description || 'Failed to add to cart')
            }

            atcBtn.classList.remove('is-adding')
            atcBtn.classList.add('is-added')
            atcBtn.textContent = 'Added'

            // Fetch updated cart and notify slide cart
            const cartRes = await fetch('/cart.js')
            const cartData = await cartRes.json()
            window.dispatchEvent(
                new CustomEvent('cart:updated', { detail: cartData }),
            )

            setTimeout(() => {
                atcBtn.classList.remove('is-added')
                atcBtn.textContent = 'Add to Cart'
            }, 2000)
        } catch (error) {
            atcBtn.classList.remove('is-adding')
            atcBtn.textContent = 'Error — Try Again'

            setTimeout(() => {
                atcBtn.textContent = 'Add to Cart'
            }, 2500)
        }
    })
}

const setupProductModal = () => {
    setupProductModalSlider()
    controlProductModalAnimations()
    setupProductModalATC()

    productModalNode.classList.add('is-swapped')
}

const closeProductModal = () => {
    productModalBackdropNode.classList.remove('is-visible')

    animateProductModalClose.seek(0).pause()
    animateProductModalClose.play()
}

const openProductModal = (thumbNode) => {
    populateProductModalHeader(thumbNode)

    productModalNode.classList.add('is-open')
    document.body.classList.add('is-lockscroll')

    animateProductModalOpen.seek(0).pause()
    animateProductModalOpen.tweenTo('reveal')
}

productModalBodyNode.addEventListener('htmx:afterSwap', () => {
    setupProductModal()

    productModalBackdropNode.classList.add('is-visible')

    animateProductModalOpen.tweenTo('expand')
})

closeNode.addEventListener('click', closeProductModal)
productModalBackdropNode.addEventListener('click', closeProductModal)

// –––––––––––––––––––––––––––– [ CONTACT FORM ]

const contactFormNode = document.querySelector('.contact-form')

const openContactForm = () => {
    if (!contactFormNode) return
    contactFormNode.classList.add('is-visible')
    document.body.classList.add('is-lockscroll')
}

const closeContactForm = () => {
    if (!contactFormNode) return
    contactFormNode.classList.remove('is-visible')
    document.body.classList.remove('is-lockscroll')
}

if (contactFormNode) {
    const contactFormCloseNode = contactFormNode.querySelector(
        '.contact-form__close',
    )
    const contactFormBackdropNode = contactFormNode.querySelector(
        '.contact-form__backdrop',
    )

    contactFormCloseNode.addEventListener('click', () => {
        closeContactForm()
    })

    contactFormBackdropNode.addEventListener('click', () => {
        closeContactForm()
    })
}

const inquireNode = document.querySelector('.header__inquire')

if (inquireNode) {
    inquireNode.addEventListener('click', () => {
        openContactForm()
    })
}

let isLenisFirstScroll = true
let isContactFormOpenedOnce = false

lenis.on('scroll', ({ scroll, limit }) => {
    if (isLenisFirstScroll) {
        return
    }

    if (isContactFormOpenedOnce) return

    if (scroll >= limit) {
        setTimeout(() => {
            if (isContactFormOpenedOnce) return

            if (scroll >= limit) {
                isContactFormOpenedOnce = true
                openContactForm()
            }
        }, 2000)
    }
})

setTimeout(() => {
    isLenisFirstScroll = false
}, 5000)

// –––––––––––––––––––––––––––– [ HERO ]

const heroNode = document.querySelector('.hero')
const heroTaglinesNode = heroNode?.querySelector('.hero__taglines')
const heroTaglinesNodes = heroNode?.querySelectorAll('.hero__tagline') ?? []

let isHeroHover = false
let pointerCoordiantes = {
    x: null,
    y: null,
}
let maskCoordiantes = {
    x: null,
    y: null,
}

const animateHeroMask = () => {
    maskCoordiantes = {
        x: lerp(maskCoordiantes.x, pointerCoordiantes.x, 0.25),
        y: lerp(maskCoordiantes.y, pointerCoordiantes.y, 0.25),
    }

    heroNode.style.setProperty('--x', maskCoordiantes.x + 'px')
    heroNode.style.setProperty('--y', maskCoordiantes.y + 'px')

    if (isHeroHover) {
        window.requestAnimationFrame(animateHeroMask)
    }
}

const handleHeroMousemove = (event) => {
    pointerCoordiantes = {
        x: event.clientX,
        y: event.clientY,
    }

    if (!isHeroHover) {
        isHeroHover = true

        heroTaglinesNode.classList.add('is-masked')

        maskCoordiantes = {
            x: event.clientX,
            y: event.clientY,
        }

        animateHeroMask()

        heroNode.addEventListener('mouseleave', handleHeroMouseleave)
    }
}

const handleHeroMouseleave = () => {
    isHeroHover = false

    heroTaglinesNode.classList.remove('is-masked')

    heroNode.removeEventListener('mouseleave', handleHeroMouseleave)
}

const setupHeroMasking = () => {
    heroNode.width = window.innerWidth
    heroNode.height = window.innerHeight

    heroNode.addEventListener('mousemove', handleHeroMousemove)
}

const setupHeroTaglinesLoop = () => {
    heroTaglinesNodes.forEach((heroTaglinesNode, i) => {
        if (i !== 0) gsap.set(heroTaglinesNode, { opacity: 0 })
    })

    const duration = 1
    const pause = 8
    const delayOut = -4
    const stagger = duration + pause
    const repeatDelay = stagger * (heroTaglinesNodes.length - 1) + pause

    const tl = gsap
        .timeline({})
        .fromTo(
            heroTaglinesNodes,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: duration,
                stagger: {
                    each: stagger,
                    repeat: -1,
                    repeatDelay: repeatDelay,
                },
            },
            0,
        )
        .to(
            heroTaglinesNodes,
            {
                duration: duration,
                opacity: 0,
                stagger: {
                    each: stagger,
                    repeat: -1,
                    repeatDelay: repeatDelay,
                },
            },
            stagger + delayOut,
        )
}

if (heroNode) {
    setupHeroMasking()
    setupHeroTaglinesLoop()
}

// –––––––––––––––––––––––––––– [ STORY FULL BLEED ]

const storyFullBleedsNodes = document.querySelectorAll('.story--full-bleed')

for (const storyFullBleedNode of storyFullBleedsNodes) {
    const storyFullBleedCopyNode = storyFullBleedNode.querySelector(
        '.story--full-bleed__copy',
    )

    const split = SplitText.create(storyFullBleedCopyNode, {
        type: 'lines, words',
        mask: 'lines',
        autoSplit: true,
    })

    gsap.from(split.lines, {
        scrollTrigger: {
            trigger: storyFullBleedCopyNode,
            start: 'top 75%',
            toggleActions: 'play none none none',
        },
        duration: 0.6,
        y: 100,
        autoAlpha: 0,
        stagger: 0.08,
    })
}

// –––––––––––––––––––––––––––– [ COLLABORATIONS ]

const collaborationsNodes = document.querySelectorAll('.collaborations')

for (const collaborationsNode of collaborationsNodes) {
    const collaborationNodes =
        collaborationsNode.querySelectorAll('.collaboration')

    for (const collaborationNode of collaborationNodes) {
        gsap.fromTo(
            collaborationNode,
            {
                y: 40,
                autoAlpha: 0,
            },
            {
                scrollTrigger: {
                    trigger: collaborationNode,
                    start: '-100 80%',
                    toggleActions: 'play none none reverse',
                },
                duration: 0.6,
                y: 0,
                autoAlpha: 1,
                stagger: 0.2,
            },
        )
    }
}

// –––––––––––––––––––––––––––– [ CHAPTERS ]

const chaptersNodes = document.querySelectorAll('.chapters')

for (const chaptersNode of chaptersNodes) {
    const chapterNodes = chaptersNode.querySelectorAll('.chapter')

    for (const chapterNode of chapterNodes) {
        const chapterCopyContentNode = chapterNode.querySelector(
            '.chapter__copy__content',
        )

        ScrollTrigger.create({
            trigger: chapterCopyContentNode,
            start: 'top 70%',
            toggleActions: 'play none none none',
            toggleClass: 'is-visible',
            once: true,
        })
    }
}

// –––––––––––––––––––––––––––– [ MOODS ]

const setupMoods = (moodsNode) => {
    const moodsSliderNode = moodsNode.querySelector('.moods__slider')
    const moodsContainerNode = moodsNode.querySelector('.moods__container')

    gsap.to(moodsContainerNode, {
        x: () =>
            -(moodsContainerNode.scrollWidth - moodsSliderNode.offsetWidth),
        ease: 'none',
        scrollTrigger: {
            trigger: moodsSliderNode,
            start: 'center center',
            end: () =>
                '+=' +
                (moodsContainerNode.scrollWidth - moodsSliderNode.offsetWidth),
            pin: document.querySelector('#index'),
            scrub: true,
            invalidateOnRefresh: true,
        },
    })
}

const moodsNodes = document.querySelectorAll('.moods')

for (const moodsNode of moodsNodes) {
    setupMoods(moodsNode)
}
